import React, { Component } from "react";
import { connect } from "react-redux";
import DatePicker from "react-datepicker";
import { ApplicationStore } from "src/store";
import { CalendarIcon } from "Shared/Icons";
import "./Datepicker.scss";

interface DatepickerProps {
    selectedDate: any;
    minDate: any;
    placeholderText: string | undefined;
    reportUp: (date: any) => void;
    inputDisabled?: boolean;
    hoursOfOperation?: any;
}

class OSDatepicker extends Component<DatepickerProps> {
    private wrapperRef: any;

    constructor(props: DatepickerProps) {
        super(props);
        this.wrapperRef = React.createRef<HTMLDivElement>();
    }

    public componentDidMount() {
        if (this.props.inputDisabled) {
            this.disableInput();
        }
    }

    public render() {
        return (
            <div className="OSDatepicker">
                <DatePicker
                    ref={this.wrapperRef}
                    onFocus={this.onFocus}
                    selected={this.props.selectedDate}
                    onChange={this.handleChange}
                    className="OSDatepicker__input"
                    minDate={this.props.minDate}
                    placeholderText={this.props.placeholderText}
                    popperPlacement="top"
                    popperModifiers={{
                        flip: {
                            enabled: false,
                        },
                        preventOverflow: {
                            boundariesElement: "viewport",
                            enabled: true,
                            escapeWithReference: false, // force popper to stay in viewport (even when input is scrolled out of view)
                        },
                    }}
                    filterDate={this.filterInOpenDays}
                />
                <CalendarIcon />
            </div>
        );
    }

    private onFocus = () => {
        if (this.props.inputDisabled) {
            this.disableInput();
        }
    };

    private disableInput = () => {
        if (this.wrapperRef && this.wrapperRef.current && this.wrapperRef.current.input) {
            this.wrapperRef.current.input.readOnly = true;
        }
    };

    private handleChange = (date: any, event: any) => {
        this.props.reportUp(date);
    };

    private filterInOpenDays = (date: Date) => {
        const day = date.getDay();
        return !!Object.values(this.props.hoursOfOperation)[day];
    };
}

export function mapDatePickerState({ account }: ApplicationStore) {
    return {
        hoursOfOperation: account.integration_settings?.Hours.days,
    };
}

export default connect(mapDatePickerState)(OSDatepicker);
